import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2aa23b7c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "show-header"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SpecialActiveHeader = _resolveComponent("SpecialActiveHeader");
  var _component_HomeHeader = _resolveComponent("HomeHeader");
  var _component_router_view = _resolveComponent("router-view");
  var _component_HomeAbout = _resolveComponent("HomeAbout");
  var _component_HomeFooter = _resolveComponent("HomeFooter");
  var _component_FixedButtonGroup = _resolveComponent("FixedButtonGroup");
  return _openBlock(), _createElementBlock("div", null, [_ctx.isTopWindow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.specialActiveList.includes(+_ctx.currentItemId) ? (_openBlock(), _createBlock(_component_SpecialActiveHeader, {
    key: 0
  })) : (_openBlock(), _createBlock(_component_HomeHeader, {
    key: 1
  }))])) : _createCommentVNode("", true), _createElementVNode("div", {
    style: _normalizeStyle({
      'padding-top': _ctx.isTopWindow ? '64px' : 0
    })
  }, [_createVNode(_component_router_view)], 4), _ctx.SHOW_BRAND ? (_openBlock(), _createBlock(_component_HomeAbout, {
    key: 1
  })) : _createCommentVNode("", true), _ctx.isTopWindow ? (_openBlock(), _createBlock(_component_HomeFooter, {
    key: 2
  })) : _createCommentVNode("", true), _createVNode(_Transition, {
    name: "slide-fade",
    appear: ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_FixedButtonGroup)];
    }),
    _: 1
  })]);
}